import { useMsalInstances } from "../utils/MsalInstancesContext";
import RobotaxiLogin from "../../Images/LoginImage.png";
import { PasswordSetupRequest } from "../utils/msalConfigB2C";
import logo from '../../Images/Logo-Horizontal-R.png'; // Adjust the path as necessary

const PasswordSetupPage = () => {
  const { b2cInstance } = useMsalInstances();
  const handleOwnerSiSU = async () => {
    try {
      const response = await b2cInstance.loginPopup(PasswordSetupRequest);
     // Cookies.set("idToken",response.accessToken);
       window.location.href = `${window.location.origin}/login`;
      console.log("Login successful:", response);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };
  return (
    <div className="container-fluid p-0">
      <div className="row m-0 vh-100">
        {/* Left Section: Image */}
        <div className="col-md-7 p-0">
          <img src={RobotaxiLogin} alt="Login" className="GeoparkingImage" />
        </div>
  
        {/* Right Section: Centered Content */}
        <div className="col-md-5 d-flex flex-column align-items-center justify-content-center text-center px-5">
          {/* Container to align logo and welcome text */}
          <div className="position-relative w-100 text-center">
            <img src={logo} alt="Logo" className="login-logo logo-align" />
            <h3 className="loginheader">Complete Your Setup</h3>
          </div>
  
          {/* Description */}
          <p className="accountsetupdescription">
           Create a secure password to activate your GeoParking account.
          </p>
  
          {/* Login Buttons (Same Width, White Text) */}
          <div className="text-center mt-4">
            <button className="btn btn-primary text-white setup-password-btn" onClick={handleOwnerSiSU}>
              Set Up Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordSetupPage;
